import { Outlet } from "react-router-dom";
import Header from "./../../components/v6/Header";

const HeaderPage = ({ backgroundHeader }) => {
  return (
    <>
      <Header backgroundHeader={backgroundHeader} />
      <Outlet />
    </>
  );
};

export default HeaderPage;
